<rw-modal
  modalId="maintenanceModeNotificationModal"
  datapendoid="maintenance-mode-notification-modal"
  datatestid="maintenance-mode-notification-modal"
  [title]="modalTitle"
  arialabel="Rightworks Maintenance Mode"
  [dismissible]="false"
  size="lg"
  #modalRef
>
  <div modal-body>
    <div>
      @switch (configuration?.State.toLowerCase()) {
        @case ('returntotoplevel') {
          <div>
            <span>
              Hello {{ configuration?.FirstName }}. <br />
              We are currently working on some Rightworks services behind-the-scenes. While this is processing you will
              not be able to access this client. Please wait 5 minutes and try your action again. if you have any
              questions, please contact
              {{ configuration?.MaintenanceModePhone }}.
            </span>
          </div>
        }
        @case ('logoutonly') {
          <div>
            <span>
              Hello {{ configuration?.FirstName }}. We're currently working on some Rightworks services behind-the-scenes. While we're
              working, you won't be able to access AppHub or your Rightworks cloud-hosted desktop. If you have any
              questions in the meantime, you can call {{ configuration?.MaintenanceModePhone }} and they will be happy to assist.
            </span>
          </div>
        }
      }
    </div>
    <br />
    <div>
      @if (showOrgName) {
        <div><b>Organization: </b> {{ configuration?.OrganizationName }}</div>
      }
      <div>
        <b>Maintenance started: </b>
        @if (configuration?.StartDate) {
          {{ configuration?.StartDate | utcToLocalDate | date: 'MM/dd/yyyy hh:mm:ss a Z' }}
        }       
      </div>
      <div><b>Reason: </b> {{ configuration?.MaintenanceModeText }}</div>
    </div>
  </div>
  <div modal-footer>
    <div class="flex-row no-bottom-margin">
      <div>
        @switch (configuration?.State.toLowerCase()) {
          @case ('returntotoplevel') {
            <app-button
              id="btnReturn"
              (clickActionEmitter)="goToTopLevelOrg()"
              label="Return to Top-Level Organization"
              buttonStyle="primary"
            >
            </app-button>
          }
          @case ('logoutonly') {
            <app-button id="btnLogout" (clickActionEmitter)="logout()" label="Logout" buttonStyle="teritary">
            </app-button>
          }
        }
      </div>
    </div>
  </div>
</rw-modal>
